module.exports = __webpack_public_path__ + "static/media/ungroup-users.6ba811aa.svg";